import getClauseIdsForSectionType from './getClauseIdsForSectionType';
import ClauseSectionType from '../types/ClauseSectionType';
import store from '../../store/store';
import ClauseTypeType from '../../store/schema/ClauseTypeType';
export default function getExistingClauseTypesInSection(sectionType: ClauseSectionType) {
    let existingClauseTypesMap = new Map<ClauseTypeType, string>();
    let clauseIds = getClauseIdsForSectionType(sectionType);
    for (let clauseId of clauseIds) {
        let clause = store.inboxRulesEditState.clauseMap.get(clauseId);
        existingClauseTypesMap.set(clause.clauseType, clauseId);
    }
    return existingClauseTypesMap;
}
